import { useCheckinConstant } from "Hooks/checkin/useCheckinConstant";
import React, { useState } from "react";
import { Box, Button, Menu, MenuItem } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import { intersectionBy } from "lodash";
const CheckinsDropdown = ({ name }) => {
  const { checkinTypeSelection, checkinsPermission } = useCheckinConstant();

  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const selectCheckins = (checkin) => {
    setValue(`${name}.current`, {
      type: checkin.type,
      title: checkin.title,
      targetMode: "createCheckinTemplate",
      checkinMode: "create",
      checkinModal: true,
    });
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        variant="contained"
        color="primary"
      >
        Create
        <ExpandMoreOutlinedIcon fontSize="small" className="ml5" />
      </Button>
      <Menu
        id="simple-menu"
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {/* {checkinTypeSelection */}
        {(
          intersectionBy(
            [...checkinTypeSelection],
            [...checkinsPermission],
            "type"
          ) || []
        ).map((item, key) => {
          return (
            <MenuItem onClick={() => selectCheckins(item)}>
              {item.title}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

export default CheckinsDropdown;
